import type { Permission, Role } from "./types";

export const ROLE_LABELS: Record<Role, string> = {
  owner: "Owner",
  admin: "Admin",
  developer: "Developer",
  viewer: "Viewer",
};

/** What each role can do, as shown when inviting someone. */
export const ROLE_DESCRIPTIONS: Record<Role, string> = {
  owner: "Everything, including managing owners.",
  admin: "Everything except managing owners: payouts, team and activity log.",
  developer: "API keys, webhooks, payment links and checkout. Cannot change payouts.",
  viewer: "Read-only access to payments and settings.",
};

/** Why an action is unavailable, for read-only notices and disabled controls. */
export const PERMISSION_HINTS: Record<Permission, string> = {
  "profile.write": "Only owners and admins can change the business details.",
  "settlement.write": "Only owners and admins can change payout settings.",
  "hosted.write": "Only owners, admins and developers can change checkout.",
  "payments.write": "Only owners, admins and developers can create or accept payments.",
  "developers.write": "Only owners, admins and developers can manage API keys and webhooks.",
  "team.write": "Only owners and admins can manage the team.",
  "audit.read": "Only owners and admins can see the activity log.",
  "payouts.address": "Only owners can change payout addresses.",
};
